import React from 'react';
import styled from "styled-components";

const AnswerButton = (props) => {
    return (
        <Button>
            <input type="radio" id={props.id} name={props.name} value={props.value} onChange={props.changeHandler} defaultChecked={Number(props.selected) === props.value}/>
            <label htmlFor={props.id}>
                {props.text}
            </label>
        </Button>
    );
};

const Button = styled.div`
    display: inline-flex;
    width: calc(100% / 7);
    justify-content: center;
    align-items: center;
    height: 100%;
    box-sizing: border-box;

    & + & {
        label {
            border-left: 0;
        }
    }
    
    label {
        width: 100%;
        font-size: 14.5px;
        color: #7f7f7f;
        font-weight: normal;
        box-sizing: border-box;
        border: none;
        text-align: center;
        height:100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: white;
        border: 2px solid #a5a5a5;
    }
    
    input {
        display: none;

        &:checked {
            + label {
                background-color: #9fbcce;
                color: #000;
                font-weight: bold;
                position: relative;

                &::after {
                    content:"";
                    position: absolute;
                    top:-2px;
                    left:-2px;
                    width:100%;
                    height: 100%;
                    border:2px solid #000;
                }
            }
        }
    }
`;

export default AnswerButton;
